import * as types from "./types";

export default {
  [types.SET_CUSTOMERLIST](state, payload) {
    state.customerList = payload;
  }
};
